// Action
export const sagaActions = {
  FETCH_DATA_SAGA: "LoginData",
  FETCH_FORGOT_DATA_SAGA: "ForgotOtpLoginData",
  FETCH_VERIFY_OTP_DATA_SAGA: "VerifyOtpLoginData",
  FETCH_RESET_PASSWORD_DATA_SAGA: "ResetPasswordLoginData",
  FETCH_DATA_PLANTS: "plantListRetrieve",
  FETCH_DATA_CLIENT: "clientListRetrieve",
  FETCH_FILE_LIST: "fileListRetrieve",
  FETCH_DATA_CREATE_PLANT: "createPlant",
  FETCH_DATA_CREATE_PROJECT: "createProject",
  FETCH_DATA_PROJECT_WBS: "fetchProjectWbs",
  FETCH_DATA_CREATE_PROJECT_WBS: "createProjectWbs",
  FETCH_DATA_UPDATE_PLANT: "updatePlant",
  FETCH_DATA_UPDATE_PROJECT: "updateProject",
  FETCH_DATA_UPDATE_PROJECT_WBS: "updateProjectWbs",
  FETCH_DATA_CREATE_SCHEDULE: "createSchedule",
  FETCH_DATA_RETRIEVE_INVOICE: "retrieveinvoice",
  FETCH_DATA_RETRIEVE_NEWINVOICE: "retrieveinvoice",
  FETCH_DATA_RETRIEVE_SCHEDULED_INVOICE: "retrievescheduledinvoice",
  FETCH_PLANT_DROP: "plantListgetdrop",
  FETCH_PROJECT_DROP: "projectListgetdrop",
  FETCH_PROJECTWBS_DROP: "projectwbsListgetdrop",
  FETCH_USERDATA: "UserGet",
  FETCH_USERDATA_POST: "UserPost",
  FETCH_USERDATA_PUT: "UserPut",
  FETCH_COMMON_POST: "CommonPost",
  FETCH_DATA_PROJECT: "graphListRetrieve",
};
